/**
 * Filtry kategorie — vodorovná lišta dropdownů
 *
 * Převzato z www.abstore.cz (zadání klienta). Nativní panel filtrů Shoptetu
 * se skryje a jeho sekce se PŘESUNOU do našich panelů. Klíčové je, že se
 * inputy stěhují, ne klonují: Shoptet na ně má delegované obsluhy
 * (odesílá formulář a překresluje výpis), takže s originálními prvky
 * filtrování dál funguje samo a my řešíme jen obal.
 *
 * Skladba:
 *   - do 5 filtrů (6 nad 1700 px) jde do lišty jako tlačítko + panel,
 *   - zbytek je dostupný přes „Další parametry“, které otevřou šuplík,
 *   - na mobilu (≤767 px) otevírá šuplík každé tlačítko,
 *   - pod lištou jsou pilulky aktivních filtrů s křížkem.
 *
 * Panely lišty a řádky šuplíku sdílejí TYTÉŽ .category-filters__content —
 * při otevření/zavření šuplíku se přesouvají tam a zpět, aby nikdy
 * neexistovaly dvě kopie stejného inputu (dvě kopie = rozbité filtrování).
 *
 * Vzhled řeší CSS v components/category-filters.scss.
 */
(function () {
	var MOBILE_BP = 767;
	// Kolik filtrů zůstane v liště; zbytek jde do šuplíku.
	// Drží se v souladu s $toolbar-visible v category-filters.scss.
	var VISIBLE = 5;
	var VISIBLE_WIDE = 6;
	var WIDE_BP = 1700;

	// Filtry přesunuté do panelů. Každá položka drží obsah a oba jeho
	// možné rodiče (panel v liště / řádek v šuplíku).
	var sections = [];
	// Sekce s .param-filter-top (štítky, dostupnost). Shoptet je podle
	// nastavení kategorie vypíše buď v jedné sekci, nebo každou zvlášť —
	// proto pole, ne jediný prvek.
	var tagsSections = [];
	var sidebar = null;
	var overlay = null;
	var scrollY = 0;
	// Observer nad tlačítkem „Zobrazit produkty“ — při přestavbě se odpojí,
	// jinak by jich po každém filtrování přibyl další.
	var submitObserver = null;

	function isMobile() {
		return window.matchMedia('(max-width: ' + MOBILE_BP + 'px)').matches;
	}

	function visibleCount() {
		return window.innerWidth >= WIDE_BP ? VISIBLE_WIDE : VISIBLE;
	}

	function el(tag, className, html) {
		var node = document.createElement(tag);
		if (className) node.className = className;
		if (html != null) node.innerHTML = html;
		return node;
	}

	function checkedIn(node) {
		return node.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length > 0;
	}

	// Popisek sekce — Shoptet ho má v <h4><span>, u booleovských sekcí
	// (bez nadpisu) padneme zpět na předaný výchozí text.
	function labelOf(node, fallback) {
		var heading = node.querySelector('h4 span, h4');
		if (!heading) return fallback;
		var clone = heading.cloneNode(true);
		var count = clone.querySelector('.filter-count');
		if (count) count.parentNode.removeChild(count);
		return clone.textContent.trim() || fallback;
	}

	// -----------------------------------------------------
	//  Cena — je vybraný užší rozsah, než jaký kategorie nabízí?
	// -----------------------------------------------------
	function priceValues(scope) {
		var min = scope.querySelector('#price-value-min');
		var max = scope.querySelector('#price-value-max');
		var catMin = scope.querySelector('#categoryMinValue');
		var catMax = scope.querySelector('#categoryMaxValue');
		if (!min || !max || !catMin || !catMax) return null;
		return {
			min: parseInt(min.value, 10),
			max: parseInt(max.value, 10),
			catMin: parseInt(catMin.textContent, 10),
			catMax: parseInt(catMax.textContent, 10),
		};
	}

	function priceActive(scope) {
		var v = priceValues(scope);
		if (!v) return false;
		return v.min > v.catMin || v.max < v.catMax;
	}

	// Slider nemá smysl, když jsou všechny produkty za stejnou cenu.
	function priceUsable(scope) {
		var v = priceValues(scope);
		if (!v) return false;
		if (isNaN(v.catMin) || isNaN(v.catMax)) return false;
		return v.catMax - v.catMin >= 2 || priceActive(scope);
	}

	// -----------------------------------------------------
	//  Stav tlačítka v liště
	// -----------------------------------------------------
	function refreshItem(item) {
		var value = item.querySelector('.category-filters__value');
		if (!value) return;
		var content = item.querySelector('.category-filters__content');
		// Panel může být zrovna přestěhovaný do šuplíku — stav se pak
		// čte z obsahu, který si položka pamatuje.
		if (!content) {
			var entry = sections.filter(function (s) {
				return s.toolbarPanel && s.toolbarPanel.parentNode === item;
			})[0];
			content = entry ? entry.content : null;
		}
		if (!content) return;

		var active = content.classList.contains('category-filters__content--price')
			? priceActive(content)
			: checkedIn(content);

		value.textContent = active ? 'Vybráno' : 'Vyberte hodnotu';
		item.classList.toggle('category-filters__item--active', active);
	}

	function refreshAll() {
		Array.prototype.forEach.call(document.querySelectorAll('.category-filters__item:not(.category-filters__item--more)'), refreshItem);
		refreshBadge();
	}

	// Počet vybraných filtrů na odznaku u „Dalších parametrů“.
	function refreshBadge() {
		var badge = document.querySelector('.category-filters__more-badge');
		if (!badge) return;
		var seen = {};
		var count = 0;
		var scopes = document.querySelectorAll('.category-filters, .category-filters-sidebar');
		Array.prototype.forEach.call(scopes, function (scope) {
			Array.prototype.forEach.call(scope.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked'), function (input) {
				var key = input.id || input.name + '=' + input.value;
				if (seen[key]) return;
				seen[key] = true;
				count++;
			});
		});
		badge.textContent = String(count);
		badge.classList.toggle('category-filters__more-badge--visible', count > 0);
	}

	// -----------------------------------------------------
	//  Zámek scrollu pod šuplíkem
	// -----------------------------------------------------
	function lockScroll() {
		if (document.body.classList.contains('category-filters-sidebar-open')) return;
		scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
		document.body.style.top = -scrollY + 'px';
		document.body.classList.add('category-filters-sidebar-open');
	}

	function unlockScroll() {
		if (!document.body.classList.contains('category-filters-sidebar-open')) return;
		document.body.classList.remove('category-filters-sidebar-open');
		document.body.style.top = '';
		window.scrollTo(0, scrollY);
	}

	// -----------------------------------------------------
	//  Sběr sekcí z nativního panelu
	// -----------------------------------------------------
	function collect(filters) {
		var found = [];

		// Cena — slider i skrytý formulář musí jít do panelu spolu,
		// Shoptet je čte dohromady. Rozsah se čte ještě PŘED přesunem,
		// dokud jsou oba prvky pohromadě v #filters.
		var slider = filters.querySelector('.slider-wrapper');
		var priceForm = filters.querySelector('#price-filter-form');
		if (slider && priceUsable(filters)) {
			var priceContent = el('div', 'category-filters__content category-filters__content--price');
			priceContent.appendChild(slider);
			if (priceForm) priceContent.appendChild(priceForm);
			found.push({ label: 'Cena', content: priceContent, isPrice: true });
		}

		// Booleovské sekce (dostupnost, štítky). Sekce s .param-filter-top
		// jsou štítky — ty jdou do šuplíku jako barevné pilulky, ne do lišty.
		// Na referenci je taková sekce jediná, ale Shoptet jich podle
		// nastavení kategorie může vypsat víc.
		Array.prototype.forEach.call(filters.querySelectorAll('.filter-sections > .filter-section-boolean'), function (section) {
			if (section.querySelector('.param-filter-top')) return;
			var content = el('div', 'category-filters__content');
			content.appendChild(section);
			found.push({ label: labelOf(content, 'Filtr'), content: content });
		});

		// Značka a parametrické filtry (barva, rozměry…). Obojí bydlí
		// v #category-filter-hover, které Disco schovává pod „Rozbalit
		// filtr“ — u nás je to obsah panelů, takže se bere celé.
		// Značka má vlastní id, ostatní třídu .filter-section-parametric;
		// jeden selektor pro obojí, aby se pořadí z administrace
		// zachovalo a nic se nevzalo dvakrát.
		Array.prototype.forEach.call(filters.querySelectorAll('#manufacturer-filter, .filter-section-parametric'), function (section) {
			var content = el('div', 'category-filters__content');
			content.appendChild(section);
			found.push({ label: labelOf(content, 'Parametr'), content: content });
		});

		return found;
	}

	// -----------------------------------------------------
	//  Lišta
	// -----------------------------------------------------
	function buildToolbar(filters, wrapper) {
		var bar = el('div', 'category-filters');
		var limit = visibleCount();
		var hiddenActive = false;

		sections.forEach(function (entry, index) {
			if (index >= limit) {
				// Filtr zůstane jen v šuplíku.
				if (checkedIn(entry.content)) hiddenActive = true;
				return;
			}

			var item = el('div', 'category-filters__item');
			item.setAttribute('data-filter-label', entry.label);

			var toggle = el(
				'button',
				'category-filters__toggle',
				'<span class="category-filters__label">' +
					entry.label +
					'<span class="category-filters__active-dot"></span></span>' +
					'<span class="category-filters__value">Vyberte hodnotu</span>' +
					'<i class="category-filters__chevron" aria-hidden="true"></i>'
			);
			toggle.type = 'button';
			toggle.setAttribute('aria-expanded', 'false');

			var panel = el('div', 'category-filters__panel');
			panel.appendChild(entry.content);

			entry.toolbarPanel = panel;
			entry.item = item;

			item.appendChild(toggle);
			item.appendChild(panel);
			bar.appendChild(item);
			refreshItem(item);
		});

		// „Další parametry“ — vždy, i když se všechno vešlo: je to
		// jediná cesta ke štítkům a na mobilu k celému šuplíku.
		var more = el('div', 'category-filters__item category-filters__item--more');
		var moreBtn = el(
			'button',
			'category-filters__toggle category-filters__more',
			'<svg class="category-filters__more-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
				'<path d="M4 6h8M16 6h4M4 12h4M12 12h8M4 18h10M18 18h2"/>' +
				'<circle cx="14" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="16" cy="18" r="2"/>' +
				'</svg>' +
				'<span class="category-filters__more-label">Další parametry</span>' +
				'<span class="category-filters__more-badge"></span>'
		);
		moreBtn.type = 'button';
		more.appendChild(moreBtn);
		if (hiddenActive) more.classList.add('category-filters__item--active');
		bar.appendChild(more);

		filters.classList.add('no-display');
		wrapper.insertBefore(bar, wrapper.firstChild);

		bar.addEventListener('click', function (event) {
			var toggleEl = event.target.closest('.category-filters__toggle');
			if (!toggleEl) return;
			event.preventDefault();
			event.stopPropagation();

			if (toggleEl.classList.contains('category-filters__more')) {
				openSidebar();
				return;
			}

			// Na mobilu nahrazuje panely šuplík.
			if (isMobile()) {
				openSidebar(toggleEl.closest('.category-filters__item').getAttribute('data-filter-label'));
				return;
			}

			var item = toggleEl.closest('.category-filters__item');
			var wasOpen = item.classList.contains('category-filters__item--open');
			closePanels();
			if (!wasOpen) {
				item.classList.add('category-filters__item--open');
				toggleEl.setAttribute('aria-expanded', 'true');
			}
		});

		return bar;
	}

	function closePanels() {
		Array.prototype.forEach.call(document.querySelectorAll('.category-filters__item--open'), function (item) {
			item.classList.remove('category-filters__item--open');
			var toggle = item.querySelector('.category-filters__toggle');
			if (toggle) toggle.setAttribute('aria-expanded', 'false');
		});
	}

	// -----------------------------------------------------
	//  Šuplík
	// -----------------------------------------------------
	function buildSidebar() {
		overlay = el('div', 'category-filters-sidebar-overlay');
		sidebar = el('div', 'category-filters-sidebar');

		var header = el('div', 'category-filters-sidebar__header', '<button type="button" class="category-filters-sidebar__close" aria-label="Zavřít">&times;</button>');
		var body = el('div', 'category-filters-sidebar__body');

		if (tagsSections.length) {
			var tags = el('div', 'category-filters-sidebar__tags', '<h3 class="category-filters-sidebar__tags-title">Štítky a dostupnost</h3>');
			tagsSections.forEach(function (section) {
				tags.appendChild(section);
			});
			body.appendChild(tags);
		}

		var accordion = el('div', 'category-filters-sidebar__accordion');
		sections.forEach(function (entry) {
			var row = el(
				'div',
				'category-filters-sidebar__row',
				'<button type="button" class="category-filters-sidebar__row-toggle">' +
					'<span class="category-filters-sidebar__row-label">' +
					entry.label +
					'<span class="category-filters__active-dot"></span></span>' +
					'<i class="category-filters__chevron" aria-hidden="true"></i>' +
					'</button>'
			);
			row.setAttribute('data-filter-label', entry.label);

			var panel = el('div', 'category-filters-sidebar__row-panel');
			row.appendChild(panel);
			accordion.appendChild(row);

			if (checkedIn(entry.content)) row.classList.add('category-filters-sidebar__row--active');
			entry.sidebarRow = row;
			entry.sidebarPanel = panel;

			// Filtry, které se do lišty nevešly, bydlí rovnou tady.
			if (!entry.toolbarPanel) panel.appendChild(entry.content);
		});
		body.appendChild(accordion);

		var footer = el(
			'div',
			'category-filters-sidebar__footer',
			'<button type="button" class="category-filters-sidebar__reset">Zrušit filtry</button>' +
				'<button type="button" class="category-filters-sidebar__submit">Zobrazit produkty</button>'
		);

		sidebar.appendChild(header);
		sidebar.appendChild(body);
		sidebar.appendChild(footer);
		document.body.appendChild(overlay);
		document.body.appendChild(sidebar);

		accordion.addEventListener('click', function (event) {
			var toggle = event.target.closest('.category-filters-sidebar__row-toggle');
			if (!toggle) return;
			event.preventDefault();
			var row = toggle.closest('.category-filters-sidebar__row');
			var wasOpen = row.classList.contains('category-filters-sidebar__row--open');
			Array.prototype.forEach.call(accordion.querySelectorAll('.category-filters-sidebar__row--open'), function (open) {
				open.classList.remove('category-filters-sidebar__row--open');
			});
			if (!wasOpen) row.classList.add('category-filters-sidebar__row--open');
		});

		header.addEventListener('click', function (event) {
			if (event.target.closest('.category-filters-sidebar__close')) closeSidebar();
		});
		overlay.addEventListener('click', closeSidebar);

		footer.addEventListener('click', function (event) {
			if (event.target.closest('.category-filters-sidebar__submit')) {
				closeSidebar();
				return;
			}
			if (event.target.closest('.category-filters-sidebar__reset')) {
				// Zrušení filtrů = holá URL kategorie bez parametrů.
				window.location.href = window.location.origin + window.location.pathname;
			}
		});

		// Na tlačítku „Zobrazit produkty“ je počet vyfiltrovaných položek.
		// Shoptet ho po překreslení výpisu přepíše, proto observer.
		var lastCount = null;
		function syncSubmit() {
			var total = document.querySelector('.category-header-pagination strong');
			var text = total ? total.textContent.trim() : '';
			if (text === lastCount) return;
			lastCount = text;
			var submit = footer.querySelector('.category-filters-sidebar__submit');
			if (submit) submit.textContent = text ? 'Zobrazit produkty (' + text + ')' : 'Zobrazit produkty';
		}
		syncSubmit();
		submitObserver = new MutationObserver(syncSubmit);
		submitObserver.observe(document.body, { childList: true, subtree: true });
	}

	function openSidebar(focusLabel) {
		if (!sidebar) return;
		// Obsah panelů se stěhuje do řádků šuplíku — nikdy nesmí být
		// na dvou místech naráz.
		sections.forEach(function (entry) {
			if (entry.sidebarPanel) entry.sidebarPanel.appendChild(entry.content);
		});
		closePanels();

		if (focusLabel) {
			var row = sidebar.querySelector('.category-filters-sidebar__row[data-filter-label="' + focusLabel.replace(/"/g, '\\"') + '"]');
			if (row) row.classList.add('category-filters-sidebar__row--open');
		}

		lockScroll();
		sidebar.classList.add('category-filters-sidebar--open');
		overlay.classList.add('category-filters-sidebar-overlay--visible');
	}

	function closeSidebar() {
		if (!sidebar) return;
		unlockScroll();
		sidebar.classList.remove('category-filters-sidebar--open');
		overlay.classList.remove('category-filters-sidebar-overlay--visible');

		// Obsah zpátky do panelů lišty.
		sections.forEach(function (entry) {
			if (entry.toolbarPanel) entry.toolbarPanel.appendChild(entry.content);
		});
		Array.prototype.forEach.call(sidebar.querySelectorAll('.category-filters-sidebar__row--open'), function (row) {
			row.classList.remove('category-filters-sidebar__row--open');
		});
		refreshAll();
	}

	// -----------------------------------------------------
	//  Pilulky aktivních filtrů
	// -----------------------------------------------------
	function formatPrice(value) {
		return value.toLocaleString('cs-CZ');
	}

	function buildActiveFilters() {
		if (document.querySelector('.category-active-filters')) return;

		var scope = document.querySelector('.category-filters');
		if (!scope) return;

		var list = el('div', 'category-active-filters__list');

		function pill(label, text, href, modifier, swatch) {
			var a = el(
				'a',
				'category-active-filters__pill',
				'<span class="category-active-filters__pill-label"></span>' +
					'<span class="category-active-filters__pill-text"></span>' +
					'<span class="category-active-filters__pill-remove" aria-hidden="true"></span>'
			);
			a.href = href;
			if (modifier) a.classList.add('category-active-filters__pill--' + modifier);

			var labelEl = a.querySelector('.category-active-filters__pill-label');
			if (label) labelEl.textContent = label + ':';
			else labelEl.parentNode.removeChild(labelEl);

			var textEl = a.querySelector('.category-active-filters__pill-text');
			if (swatch) {
				var dot = el('span', 'category-active-filters__pill-swatch');
				dot.style.backgroundColor = swatch;
				textEl.parentNode.insertBefore(dot, textEl);
			}
			textEl.textContent = text;
			list.appendChild(a);
		}

		// Zaškrtnuté filtry hledáme i v šuplíku — část jich tam bydlí.
		var roots = [scope];
		if (sidebar) roots.push(sidebar);
		roots.forEach(function (root) {
			Array.prototype.forEach.call(root.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked'), function (input) {
				var url = input.getAttribute('data-url');
				if (!url) return;

				// Popisek je vždy v <label for>, ne uvnitř inputu.
				// ID Shoptetu obsahují hranaté závorky (dd[]8, pv[]302),
				// proto CSS.escape — bez něj je selektor neplatný.
				var label = null;
				if (input.id) {
					try {
						label = root.querySelector('label[for="' + CSS.escape(input.id) + '"]');
					} catch (e) {
						label = null;
					}
				}

				var text = '';
				if (label) {
					var clone = label.cloneNode(true);
					var count = clone.querySelector('.filter-count');
					if (count) count.parentNode.removeChild(count);
					text = clone.textContent.trim();
					// Barevné swatche mají místo textu jen obrázek —
					// název barvy je v title labelu.
					if (!text) text = (label.getAttribute('title') || '').trim();
				}
				if (!text) text = (input.value || '').trim();

				// Barevný parametr: buď inline background-color, nebo
				// obrázek vzorku. Prázdný swatch se do pilulky nekreslí.
				var swatch = '';
				var inner = label ? label.querySelector('.advanced-parameter-inner') : null;
				if (inner) swatch = inner.style.backgroundColor;

				var section = input.closest('.category-filters__content, .filter-section');
				var heading = section ? section.querySelector('h4') : null;
				var groupLabel = heading ? heading.textContent.trim() : '';

				var isTag = !!input.closest('.param-filter-top, .category-filters-sidebar__tags');
				// Dostupnost sedí ve stejné sekci jako štítky, ale štítek to není.
				if (isTag) pill(input.name === 'stock' ? 'Dostupnost' : 'Štítek', text, url, 'tag');
				else pill(groupLabel, text, url, '', swatch);
			});
		});

		// Cena je vlastní pilulka — není to checkbox.
		var priceScope = document.querySelector('.category-filters__content--price') || scope;
		var v = priceValues(priceScope);
		if (v && (v.min > v.catMin || v.max < v.catMax)) {
			var url = new URL(window.location.href);
			url.searchParams.delete('priceMin');
			url.searchParams.delete('priceMax');
			pill('Cena', formatPrice(v.min) + ' – ' + formatPrice(v.max) + ' Kč', url.toString());
		}

		if (!list.children.length) return;

		var box = el('div', 'category-active-filters', '<span class="category-active-filters__label">Aktivní filtry:</span>');
		box.appendChild(list);
		box.appendChild(
			el(
				'a',
				'category-active-filters__clear',
				'<svg class="category-active-filters__clear-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
					'<path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>' +
					'<span>Vymazat vše</span>'
			)
		);
		box.querySelector('.category-active-filters__clear').href = window.location.origin + window.location.pathname;
		scope.appendChild(box);
	}

	// -----------------------------------------------------
	//  Start
	// -----------------------------------------------------
	// Shoptet po filtrování nenahradí jen obsah, ale celý #filters-wrapper.
	// Naše lišta tím ze stránky zmizí a musíme ji postavit znovu — jenže
	// šuplík visí na <body>, ten výměnu přežije. Bez úklidu by tu zůstal
	// viset starý (klidně otevřený) šuplík s originálními inputy uvnitř,
	// zatímco proměnné sidebar/overlay by už ukazovaly na nový. Zavírání
	// by pak sahalo vedle a filtrování by běželo na osiřelých kopiích.
	// Vrací stav šuplíku, aby ho šlo po přestavbě obnovit: šuplík zavírá
	// jen uživatel (křížek, overlay, Escape, „Zobrazit produkty“), ne
	// překreslení výpisu. Shoptet překresluje po KAŽDÉM zaškrtnutí, takže
	// bez obnovení by šuplík zmizel hned při výběru parametru.
	function teardown() {
		var state = { open: false, rows: [] };

		if (sidebar) {
			state.open = sidebar.classList.contains('category-filters-sidebar--open');
			Array.prototype.forEach.call(sidebar.querySelectorAll('.category-filters-sidebar__row--open'), function (row) {
				state.rows.push(row.getAttribute('data-filter-label'));
			});
		}

		if (submitObserver) {
			submitObserver.disconnect();
			submitObserver = null;
		}
		// Zámek scrollu drží třída na <body> a inline top. Necháváme je být,
		// pokud šuplík zůstává otevřený — jinak by stránka pod ním poskočila.
		if (!state.open) unlockScroll();
		if (sidebar && sidebar.parentNode) sidebar.parentNode.removeChild(sidebar);
		if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
		sidebar = null;
		overlay = null;
		sections = [];
		tagsSections = [];

		return state;
	}

	// Znovu otevře šuplík po přestavbě — bez animace a bez sahání na zámek
	// scrollu, ten z předchozího stavu pořád platí.
	function restoreSidebar(state) {
		if (!state.open || !sidebar) return;

		sections.forEach(function (entry) {
			if (entry.sidebarPanel) entry.sidebarPanel.appendChild(entry.content);
		});
		state.rows.forEach(function (label) {
			if (!label) return;
			var row = sidebar.querySelector('.category-filters-sidebar__row[data-filter-label="' + label.replace(/"/g, '\\"') + '"]');
			if (row) row.classList.add('category-filters-sidebar__row--open');
		});

		// Nový šuplík je zasunutý vpravo; bez potlačení přechodu by se po
		// každém zaškrtnutí zbytečně přijel.
		sidebar.classList.add('category-filters-sidebar--no-transition');
		sidebar.classList.add('category-filters-sidebar--open');
		overlay.classList.add('category-filters-sidebar-overlay--visible');
		// Vynutit přepočet stylu, než se přechod vrátí zpátky.
		void sidebar.offsetWidth;
		sidebar.classList.remove('category-filters-sidebar--no-transition');
	}

	function build() {
		var filters = document.getElementById('filters');
		var wrapper = document.getElementById('filters-wrapper');
		if (!filters || !wrapper) return;
		// Lišta je pořád na místě — Shoptet překreslil jen výpis, není co dělat.
		if (wrapper.querySelector('.category-filters')) return;
		// Wrapper je nový; po předchozím běhu musíme uklidit. Stav šuplíku
		// si neseme s sebou, aby ho překreslení nezavřelo.
		var state = teardown();

		// Štítky a dostupnost — do šuplíku jako barevné pilulky.
		tagsSections = [];
		Array.prototype.forEach.call(filters.querySelectorAll('.param-filter-top'), function (host) {
			var section = host.closest('.filter-section-boolean');
			if (section && tagsSections.indexOf(section) === -1) tagsSections.push(section);
		});

		sections = collect(filters);
		// Není co stavět — šuplík už je pryč, takže nesmí zůstat viset
		// zámek scrollu po předchozím otevření.
		if (!sections.length && !tagsSections.length) {
			unlockScroll();
			return;
		}

		buildToolbar(filters, wrapper);
		buildSidebar();
		buildActiveFilters();
		refreshAll();
		restoreSidebar(state);
	}

	// Klik mimo panel a Escape panel zavřou.
	document.addEventListener('click', function (event) {
		if (event.target.closest('.category-filters__panel, .category-filters__toggle')) return;
		closePanels();
	});

	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Escape') return;
		if (sidebar && sidebar.classList.contains('category-filters-sidebar--open')) {
			closeSidebar();
			return;
		}
		closePanels();
	});

	// Změna kteréhokoli filtru přepočítá stav tlačítek a odznaku.
	document.addEventListener('change', function (event) {
		if (!event.target.closest('.category-filters, .category-filters-sidebar')) return;
		refreshBadge();
		var item = event.target.closest('.category-filters__item');
		if (item) refreshItem(item);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', build);
	} else {
		build();
	}

	// Shoptet po filtrování překresluje výpis bez reloadu stránky.
	document.addEventListener('ShoptetDOMPageContentLoaded', build);
})();
